// @ts-check

import { useLink } from '../../../shared/link';
import { loadMyProducts } from '../../../shared/my-products';
import { useEnv } from '../../../shared/utils/env';
import { Product } from '../../../shared/utils/product';
import { extractAgencyFromUrl } from '../../../shared/utils/url';
import { redirectToSSWebApp } from './redirect-to-sswebapp';
import { basicRedirect } from './basic-redirect';
import { ordersRedirect } from './orders-redirect';

const env = useEnv({ shortened: true });
const agency = extractAgencyFromUrl(window.location.hostname) || undefined;

const managementReportingRedirect = () => {
  const base = useLink({
    product: 'compulse360',
    env,
    agency,
  });
  window.location.href = `${base}/management-reporting`;
};

const helpCenterRedirect = () => {
  const base = useLink({
    product: 'compulse360',
    env,
    agency,
  });
  window.location.href = `${base}/help`;
};

const instantIoRedirect = () => {
  const base = useLink({
    product: 'mediaplanner',
    env,
    agency,
  });
  window.location.href = `${base}?modal=insertionOrders`;
};

export const advancedPerformanceRedirect = () => {
  window.location.href = 'https://performancetv.adportal.io/';
};

export const placementsIORedirect = () => {
  window.location.href = 'https://app.placements.io/';
};

const productsSettings = new Map();

productsSettings.set(Product.Analytics, {
  meta: {
    wip: false,
    name: 'Analytics',
  },
  redirect() {
    basicRedirect('analytics', '/ahlogin');
  },
});

productsSettings.set(Product.MediaPlanner, {
  meta: {
    wip: false,
    name: 'Media \nPlanner',
  },
  redirect() {
    basicRedirect('mediaplanner');
  },
});

productsSettings.set(Product.SSWebApp, {
  meta: {
    wip: false,
    name: 'Compulse \nOMS',
  },
  redirect(token, onError) {
    redirectToSSWebApp(token, onError);
  },
});

productsSettings.set(Product.InstantIO, {
  meta: {
    wip: false,
    name: 'Instant IO',
  },
  redirect() {
    instantIoRedirect();
  },
});

productsSettings.set(Product.HelpCenter, {
  meta: {
    wip: false,
    name: 'Help \nCenter',
  },
  redirect() {
    helpCenterRedirect();
  },
});

productsSettings.set(Product.Orders, {
  meta: {
    wip: false,
    name: 'Orders',
  },
  redirect(_token, _onError, { hasAnalytics } = { hasAnalytics: false }) {
    ordersRedirect({ hasAnalytics });
  },
});

productsSettings.set(Product.Placements, {
  meta: {
    wip: false,
    name: 'Placements.io \nOMS',
  },
  redirect() {
    placementsIORedirect();
  },
});

productsSettings.set(Product.ManagementReporting, {
  meta: {
    wip: false,
    name: 'Management \nReporting',
  },
  redirect() {
    managementReportingRedirect();
  },
});
productsSettings.set(Product.CreativeGallery, {
  meta: {
    wip: false,
    name: 'Creative \nGallery',
  },
  redirect() {
    basicRedirect('creatives');
  },
});
productsSettings.set(Product.AdvancedPerformance, {
  meta: {
    wip: false,
    name: 'Advanced \nPerformance',
  },
  redirect() {
    advancedPerformanceRedirect();
  },
});

export { productsSettings };

/**
 * @param {string} token
 */
export const getMyProducts = async (token) => {
  return loadMyProducts(token);
};
